export const Step = {
  INITIAL: 1,
  RUNNING_HOURS: 2,
  NOTES: 3,
} as const;
